import React from 'react';
import { useDispatch } from 'react-redux';
import Dialog from '@shared/ui/molecules/Dialog';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import './delete-company-dialog.scss';
import { closeDialog } from '@shared/store/dialog.duck';
import { HeadlineMedium } from '@shared/ui/atoms/fonts/Headline';
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export default function DeleteCompanyDialog(props: { payload?: { company?: { name?: string } } }) {
  const selectedTeam = props.payload?.company;
  const dispatch = useDispatch();

  const close = () => {
    dispatch(closeDialog());
  }

  return (
    <Dialog isOpen={true} onClose={() => close()} className="deleteCompanyDialog">
      <HeadlineMedium className="deleteCompanyDialog__title">Delete team</HeadlineMedium>
      <div className="deleteCompanyDialog__content">
        <BodyRegular className="deleteCompanyDialog__info">Please email us at <a
          href="mailto:hello@team-today.com">hello@team-today.com</a> where we will confirm your details and process
          your deletion request for <strong>{selectedTeam?.name ?? ''}</strong>.</BodyRegular>

        <OutlineButton className="deleteCompanyDialog__button deleteCompanyDialog__cancelButton"
                       text="No don't remove team"
                       size={ButtonSize.Large}
                       fullWidth={true}
                       click={() => close()}/>
      </div>
    </Dialog>
  )
}
